// extracted by mini-css-extract-plugin
module.exports = {"cisList":"underlyingCiAlert_cisList__2d85F"};